export type RadiusType = 'none' | 'small' | 'standard' | 'big' | 'full';

export type Radii = Record<RadiusType, string | number>;

export const radii: Radii = {
	none: 0,
	small: '4px',
	standard: '8px',
	big: '12px',
	full: '50%',
};
